import React from 'react';
import './TestimonialsSection.scss';

const TestimonialsSection = () => {
  const testimonials = [
    {
      name: 'Jason Dodge',
      title: 'VP Operations, ITech Data Services',
      video: 'testimonial-1.mp4',
      thumbnail: 'testimonial-1-thumb.jpg'
    },
    {
      name: 'Kirk Smith',
      title: 'Director, Solunus',
      video: 'testimonial-2.mp4',
      thumbnail: 'testimonial-2-thumb.jpg'
    }
  ];

  return (
    <section className="testimonials section">
      <div className="container">
        <h2 className="testimonials__title">TESTIMONIALS</h2>
        <div className="testimonials__grid">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonials__card">
              <div className="testimonials__video">
                <div className="testimonials__video-placeholder">
                  {/* Placeholder for video - using image instead */}
                  <img 
                    src={require('../assets/images/profile-illustration.svg')} 
                    alt={`${testimonial.name} testimonial`}
                    className="testimonials__placeholder-image"
                  />
                  <div className="testimonials__play-button">
                    <img src={require('../assets/images/play.svg')} alt="Play" />
                  </div>
                </div>
              </div>
              <div className="testimonials__info">
                <h3 className="testimonials__name">{testimonial.name}</h3>
                <p className="testimonials__title">{testimonial.title}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection; 
